import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  message: string | null
}

/** A crash in one screen should not leave the whole pane blank. */
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { message: null }

  static getDerivedStateFromError(error: unknown): State {
    return { message: error instanceof Error ? error.message : 'Onbekende fout' }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Admin UI crashed', error, info.componentStack)
  }

  render() {
    if (this.state.message === null) return this.props.children
    return (
      <div className="state error" role="alert">
        Er ging iets mis in het beheerscherm: {this.state.message}
        <div>
          <button type="button" className="btn" onClick={() => this.setState({ message: null })}>
            Opnieuw proberen
          </button>
        </div>
      </div>
    )
  }
}
